/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteProfileRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'
import {DeleteProfileResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/profile_messages.pb'


export const deleteProfile = (request: DeleteProfileRequest, options?: CashRequestOptions) => post<DeleteProfileRequest, DeleteProfileResponse>("/2.0/cash/delete-profile", request, {...options, rejectOnError: true })